import { differenceInDays } from 'date-fns';

export const handleDaysAgo = (timeStamp: string): string => {
  const today = Date.now();
  const start = new Date(timeStamp);
  const daysAgo = differenceInDays(today, start);
  const s = daysAgo === 1 ? '' : 's';
  if (daysAgo === 0) return 'today';

  return `${daysAgo} day${s} ago`;
};
